// extracted by mini-css-extract-plugin
export default {"modal-section":"irDpE25I_Fd2mdFi20bb","title":"zzU4r5sPSjr7byDfozpT"};